import React from "react"

interface SwitchProps {
  label: string
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
}

const Switch: React.FC<SwitchProps> = ({
  label,
  checked,
  onChange,
  className = "",
}) => (
  <label className={`flex justify-between items-center ${className}`}>
    <span className="text-white text-md font-medium">{label}</span>
    <span className="relative inline-block align-middle select-none">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="peer absolute w-0 h-0 opacity-0"
      />
      <span
        className={`block rounded-full h-8 w-12 transition-colors duration-300 bg-white/10 peer-checked:bg-white/40`}
      ></span>
      <span
        className={`absolute left-1 top-1 h-6 w-6 rounded-full bg-white transition-transform duration-300 peer-checked:translate-x-4 peer-checked:bg-white`}
      ></span>
    </span>
  </label>
)

export default Switch
